module.exports = __webpack_public_path__ + "static/media/blom-pysanky-sm-7.ca527e42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-sm-7.jpg
// module id = 3895
// module chunks = 15